module.exports = __webpack_public_path__ + "static/media/pizzaAmigosEspeciales.6b304e70.jpg";